import { Tag } from "antd";
import styled from "styled-components";

export const StyledTag = styled(Tag)`
    display: inline-flex;
    align-items: center;
    margin-right: 0 !important;
    vertical-align: middle;

    .logo-icon {
        height: 16px;
    }
`;
